/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FinalizeRegisterDataRequest
 */
export interface FinalizeRegisterDataRequest {
    /**
     * 
     * @type {string}
     * @memberof FinalizeRegisterDataRequest
     */
    objectId: string;
}

/**
 * Check if a given object implements the FinalizeRegisterDataRequest interface.
 */
export function instanceOfFinalizeRegisterDataRequest(value: object): value is FinalizeRegisterDataRequest {
    if (!('objectId' in value) || value['objectId'] === undefined) return false;
    return true;
}

export function FinalizeRegisterDataRequestFromJSON(json: any): FinalizeRegisterDataRequest {
    return FinalizeRegisterDataRequestFromJSONTyped(json, false);
}

export function FinalizeRegisterDataRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinalizeRegisterDataRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'objectId': json['objectId'],
    };
}

export function FinalizeRegisterDataRequestToJSON(json: any): FinalizeRegisterDataRequest {
    return FinalizeRegisterDataRequestToJSONTyped(json, false);
}

export function FinalizeRegisterDataRequestToJSONTyped(value?: FinalizeRegisterDataRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'objectId': value['objectId'],
    };
}

